import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/spotify': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111.1 8 0 119.1 0 256S111.1 504 248 504 496 392.9 496 256 384.9 8 248 8zM348.7 372.9C344.5 372.9 341.9 371.6 338 369.3 275.6 331.7 203 330.1 131.3 344.8 127.4 345.8 122.3 347.4 119.4 347.4 109.7 347.4 103.6 339.7 103.6 331.6 103.6 321.3 109.7 316.4 117.2 314.8 199.1 296.7 282.8 298.3 354.2 341 360.3 344.9 363.9 348.4 363.9 357.5S356.8 372.9 348.7 372.9zM375.6 307.3C370.4 307.3 366.9 305 363.3 303.1 300.8 266.1 207.6 251.2 124.7 273.7 119.9 275 117.3 276.3 112.8 276.3 102.1 276.3 93.4 267.6 93.4 256.9S98.6 239.1 108.9 236.2C136.7 228.4 165.1 222.6 206.7 222.6 271.6 222.6 334.3 238.7 383.7 268.1 391.8 272.9 395 279.1 395 287.8 394.9 298.6 386.5 307.3 375.6 307.3zM406.6 231.1C401.4 231.1 398.2 229.8 393.7 227.2 322.5 184.7 195.2 174.5 112.8 197.5 109.2 198.5 104.7 200.1 99.9 200.1 86.7 200.1 76.6 189.8 76.6 176.5 76.6 162.9 85 155.2 94 152.6 129.2 142.3 168.6 137.4 211.5 137.4 284.5 137.4 361 152.6 416.9 185.2 424.7 189.7 429.8 195.9 429.8 207.8 429.8 221.4 418.8 231.1 406.6 231.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/spotify.js
// module id = NK7h
// module chunks = 144